import { z } from 'zod'
import { LeadSourceTypeEnumValues } from '@forgd/shared/enums'
import { isLinkedInOrXUrl } from '../market-maker/claim'

export const TUpdateUser = z.object({
  firstName: z.string().nullable().optional(),
  lastName: z.string().nullable().optional(),
  telegram: z.string().nullable().optional(),
  socialProfileUrl: z
    .string()
    .trim()
    .max(500)
    .refine(isLinkedInOrXUrl, 'Must be a LinkedIn or X profile URL')
    .nullable()
    .optional(),
  position: z.string().trim().max(200).nullable().optional(),
  leadSource: z.enum(LeadSourceTypeEnumValues).nullable().optional(),
  isGuidedTourEnabled: z.boolean().optional(),
})
